import { render } from "./AsBreadcrumb.vue?vue&type=template&id=bf3f5786&ts=true"
import script from "./AsBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./AsBreadcrumb.vue?vue&type=script&lang=ts"

import "./AsBreadcrumb.vue?vue&type=style&index=0&id=bf3f5786&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__